import { render, staticRenderFns } from "./ThresholdDropdown.vue?vue&type=template&id=7898b589&scoped=true"
import script from "./ThresholdDropdown.vue?vue&type=script&lang=ts"
export * from "./ThresholdDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7898b589",
  null
  
)

export default component.exports